import PropTypes from 'prop-types';

/** Small colored badge. */
export function Badge({ tone = 'brand', className = '', children }) {
  const tones = {
    brand: 'bg-brand-100 text-brand-700',
    success: 'bg-green-100 text-green-700',
    warning: 'bg-amber-100 text-amber-700',
    danger: 'bg-red-100 text-red-700',
    neutral: 'bg-slate-100 text-slate-700',
  };
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${tones[tone]} ${className}`}>
      {children}
    </span>
  );
}
Badge.propTypes = { tone: PropTypes.string, className: PropTypes.string, children: PropTypes.node };

/** Booking status → colored pill (architecture.md §19 StatusPill). */
export function StatusPill({ status }) {
  const map = {
    hold: 'warning',
    pending: 'neutral',
    awaiting_payment: 'warning',
    confirmed: 'success',
    completed: 'brand',
    cancelled: 'danger',
  };
  return <Badge tone={map[status] || 'neutral'}>{status}</Badge>;
}
StatusPill.propTypes = { status: PropTypes.string.isRequired };

/** Minimal spinner. */
export function Spinner({ className = '' }) {
  return (
    <span
      className={`inline-block h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-brand-600 ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}
Spinner.propTypes = { className: PropTypes.string };

/** Generic Skeleton Primitive */
export function Skeleton({ className = '' }) {
  return (
    <div className={`animate-pulse rounded-md bg-slate-200 ${className}`} />
  );
}
Skeleton.propTypes = { className: PropTypes.string };

/** Standard Dashboard Page Skeleton */
export function PageSkeleton() {
  return (
    <div className="space-y-6 animate-dc-rise p-1">
      <div className="space-y-3">
        <Skeleton className="h-8 w-1/4 rounded-lg" />
        <Skeleton className="h-4 w-1/3 rounded-md" />
      </div>
      <div className="rounded-[1.25rem] border border-slate-100 bg-white p-6 shadow-sm">
        <div className="mb-6 flex gap-3 border-b border-slate-50 pb-6">
          <Skeleton className="h-10 w-28 rounded-full" />
          <Skeleton className="h-10 w-28 rounded-full" />
        </div>
        <div className="space-y-4">
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}
